import * as type from '../../../actions/index.types';

const initialState = {
    loading: false,
    data: null,
    error: null,
    allComplaints: [],
    allComplaintsPagination: null,
    allComplaintsLoading: false,
    allComplaintsError: null,
};

export function CtrlDashboardReducer(state = initialState, action) {
    switch (action.type) {
        case type.GET_WEBMASTER_DASHBOARD:
            return { ...state, loading: true, error: null };
        case type.GET_WEBMASTER_DASHBOARD_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };
        case type.GET_WEBMASTER_DASHBOARD_FAILURE:
            return { ...state, loading: false, error: action?.message || 'Failed to load dashboard' };
        case type.GET_CTRL_ALL_COMPLAINTS:
            return { ...state, allComplaintsLoading: true, allComplaintsError: null };
        case type.GET_CTRL_ALL_COMPLAINTS_SUCCESS:
            return {
                ...state,
                allComplaintsLoading: false,
                allComplaints: Array.isArray(action.payload) ? action.payload : [],
                allComplaintsPagination: action.pagination || null,
                allComplaintsError: null,
            };
        case type.GET_CTRL_ALL_COMPLAINTS_FAILURE:
            return {
                ...state,
                allComplaintsLoading: false,
                allComplaints: [],
                allComplaintsPagination: null,
                allComplaintsError: action?.message || 'Failed to load complaints',
            };
        default:
            return state;
    }
}
